const appHostList = {
    dev: 'dev.app.adwisely.com',
    test: 'test.app.adwisely.com',
    test_ah: 'test-ah.app.adwisely.com',
    prod: 'app.adwisely.com',
};

export default appHostList;
